import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { bookHorse } from "../redux/actions";
import Calendar from "react-calendar";
import "../App.css";

const horses = [
  { id: 1, name: "Thunder", image: "/img/thunder.jpg" },
  { id: 2, name: "Blaze", image: "/img/blaze.jpg" },
  { id: 3, name: "Spirit", image: "/img/spirit.jpg" },
  { id: 4, name: "Shadow", image: "/img/shadow.jpg" },
];

const BookingForm = ({ setBooking }) => {
  const [horse, setHorse] = useState("");
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedHorse = horses.find((h) => h.name === horse);
    const bookingDetails = {
      horse,
      date,
      time,
      name,
      email,
      phone,
      image: selectedHorse.image,
    };
    dispatch(bookHorse(bookingDetails));
    setBooking(bookingDetails);
    navigate("/"); // Navigate back to the landing page or any other route as needed
  };

  return (
    <div className="booking-form">
      <h1>Book a Horse Ride</h1>
      <form onSubmit={handleSubmit}>
        <label>
          Horse:
          <select value={horse} onChange={(e) => setHorse(e.target.value)} required>
            <option value="">Select a horse</option>
            {horses.map((horse) => (
              <option key={horse.id} value={horse.name}>
                {horse.name}
              </option>
            ))}
          </select>
        </label>
        <label>
          Date:
          <Calendar className="calendar" onChange={setDate} value={date} />
        </label>
        <label>
          Time:
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            required
          />
        </label>
        <label>
          Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <label>
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Phone:
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="button">
          Submit
        </button>
      </form>
    </div>
  );
};

export default BookingForm;